import { TreatyBenefits } from "../steps/TreatyBenefits";
import {
  OnboardingContext,
  OnboardingModuleTreatyBenefits,
  OnboardingStep
} from "../types";

export const getTreatyBenefitsStepConfig = (
  _: OnboardingModuleTreatyBenefits,
  __: OnboardingContext,
  payeeCountry?: string
): OnboardingStep | null => {
  // Only show treaty benefits step for non-US payees
  if (payeeCountry === "US" || !payeeCountry) {
    return null;
  }

  const slug = "treaty-benefits";

  return {
    title: "Treaty benefits",
    slug,
    component: TreatyBenefits
  };
};
